import { AlertDialogAction, AlertDialogCancel, AlertDialogFooter } from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";

interface ResetActionsProps {
  isLoading: boolean;
  onConfirm: () => Promise<void>;
}

export const ResetActions = ({ isLoading, onConfirm }: ResetActionsProps) => {
  return (
    <AlertDialogFooter>
      <AlertDialogCancel>Annuler</AlertDialogCancel>
      <AlertDialogAction
        onClick={onConfirm}
        className="bg-destructive hover:bg-destructive/90"
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Réinitialisation...
          </>
        ) : (
          "Réinitialiser les données"
        )}
      </AlertDialogAction>
    </AlertDialogFooter>
  );
};